import { textareaCustomizedProps } from "./types/textareaProps";
import './textarea.scss';
import "../../../helpers/validation/validation.scss";
import { AdditionalIcon } from "../additionalIcon/additionalIcon";
import { ReactComponent as addCircle } from '../../../icons/add_circle.svg';
import { useEffect, useRef, useState } from "react";
import useAutosizeTextArea from "../../../helpers/textareHeight";
import { adjustHeight } from "../../../helpers/domHelper";

const TextArea = (props: textareaCustomizedProps) => {
    const textAreaRef = useRef<HTMLTextAreaElement>(null);
    const [value, setValue] = useState(props.props?.value ? props.props.value : "");

    //outside sync, only when textarea is not focused
    useEffect(() => {
        if (document.activeElement !== textAreaRef.current) {
            setValue((props.props?.value) ? props.props.value : "");
        }
    }, [props.props?.value])

    const onChange = (event: any) => {
        const newVal = event.target.value;

        setValue(newVal);
        //Local update only for vaidation show
        updateParentState(newVal, true);
    }

    const handleBlur = () => {
        updateParentState(value, false);
    };

    const updateParentState = (val: any, isLocal: boolean) => {
        if (props.props?.onChange) props.props?.onChange(val, isLocal);
    }

    useAutosizeTextArea(textAreaRef.current, value);

    const handleAddComment = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (props.addCommentBtn) {
            props.addCommentBtn.onClick(e);
            setTimeout(() => {
                adjustHeight(textAreaRef.current);
            }, 500);
        }
    }

    const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (props.onClickFilterComments) {
            props.onClickFilterComments(e);
        }
        adjustHeight(textAreaRef.current);
    }

    return (
        <div ref={props.textareaRef} onClick={handleClick} style={{ position: "relative", height: props.props?.style?.height ? props.props?.style?.height : "" }}>
            <textarea ref={props.dynamicResize ? textAreaRef : undefined} {...props.props} onChange={onChange} value={value} style={props.addCommentBtn?.visible ? { ...props.props?.style, paddingRight: '57px' } : props.props?.style}
                onBlur={handleBlur}
                className={props.isMarkedForCommentFilter ? `${props.props?.className} markedForCommentFilter` : `${props.props?.className}`} />
            {props.addCommentBtn?.visible &&
                <div className={`addCommentBtnWrapper addCommentBtnWrapperRegular ${props.isMarkedForCommentFilter ? "activeAddCommentBtn" : ""}`}
                    onClick={handleAddComment}>
                    {AdditionalIcon(addCircle)}
                </div>
            }
        </div>
    )
}

export default TextArea;